import React, { useRef } from 'react';
import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import { Form } from 'react-bootstrap';

export interface Props {
  ariaLabel?: string;
  ariaLabelledby?: string;
  className?: string;
  dark?: boolean;
  disabled?: boolean;
  invert?: boolean;
  label?: string | JSX.Element;
  name?: string;
  onChange?: (checked: boolean) => void;
  selected?: boolean;
  stopClickPropagation?: boolean;
  unselect?: boolean;
}

const Checkbox = ({
  ariaLabel,
  ariaLabelledby,
  className,
  dark,
  disabled = false,
  invert,
  label,
  name,
  onChange = () => {},
  selected = false,
  stopClickPropagation,
  unselect,
}: Props) => {
  const { current: id } = useRef(uniqueId('checkbox-'));

  const handleClick = (e: React.MouseEvent) => {
    if (stopClickPropagation) {
      e.stopPropagation();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      return;
    }
    onChange(e.target.checked);
  };

  const icon = unselect && !selected ? 'icon-minus' : 'icon-checkmark';

  return (
    <Form.Check
      className={classNames(className, 'checkbox d-flex', {
        dark,
        disabled,
        invert,
        unselect,
      })}
      id={id}
    >
      <Form.Check.Input
        aria-label={!label && !ariaLabelledby ? ariaLabel : undefined}
        aria-labelledby={ariaLabelledby}
        checked={selected}
        className="visually-hidden"
        disabled={disabled}
        id={id}
        name={name}
        onChange={handleChange}
        onClick={handleClick}
        type="checkbox"
      />
      <Form.Check.Label className="d-flex align-items-center" htmlFor={id} onClick={handleClick}>
        <div aria-hidden="true" className={classNames('input-checkbox', { selected })}>
          {(unselect || selected) && <i className={icon} />}
        </div>
        {typeof label === 'string' ? <span>{label}</span> : label}
      </Form.Check.Label>
    </Form.Check>
  );
};

export default Checkbox;
